import React from "react";

interface SearchHeaderProps {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  onSearch: (query: string) => void;
}

function SearchHeader({
  searchQuery,
  onSearchQueryChange,
  onSearch,
}: SearchHeaderProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  return (
    <div
      style={{ backgroundColor: "#737373" }}
      className="md:bg-gray-800 text-white sticky top-0 z-40"
    >
      <div className="max-w-4xl mx-auto px-4 pt-6 pb-4 md:pt-10 md:pb-8 sm:px-6">
        <div className="text-center mb-4 md:mb-6 lg:mb-8">
          <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold uppercase mb-1 md:mb-2 leading-tight">
            SỔ TAY 01 - TRA CỨU PHÁP LUẬT
          </h1>
          {/* <p className="text-xs sm:text-sm md:text-base lg:text-lg uppercase opacity-90">
            BỘ CÔNG AN - MINISTRY OF PUBLIC SECURITY
          </p> */}
        </div>

        <form onSubmit={handleSubmit} className="relative">
          <div className="bg-white rounded-full shadow-[0_6px_18px_rgba(0,0,0,0.12)] ring-1 ring-gray-100/70 flex items-center pr-2 pl-3 sm:pl-4 md:pl-5">
            <input
              autoFocus
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchQueryChange(e.target.value)}
              placeholder="Tìm điều luật, văn bản..."
              className="flex-1 bg-transparent h-11 sm:h-12 md:h-12 text-gray-900 placeholder-gray-400 text-sm sm:text-base md:text-lg outline-none"
            />
            <button
              type="submit"
              className="ml-2 h-9 w-16 sm:h-9 sm:w-16 md:h-10 md:w-20 rounded-full text-white text-sm font-semibold transition-colors flex items-center justify-center"
              style={{ backgroundColor: "#1677ff", cursor: "pointer" }}
            >
              Tìm
            </button>
          </div>
        </form>

        <p className="text-xs sm:text-sm text-gray-300 mt-2 md:mt-3 text-center">
          AI hỗ trợ hiểu ngữ nghĩa & trích dẫn điều luật liên quan
        </p>
      </div>
    </div>
  );
}

export default SearchHeader;
